import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BotonTipo } from '../../../components/boton/boton';
import { MatSnackBar, MatDialog } from '@angular/material';
import * as moment from 'moment';
import { CrearInformeDialog } from './crear-informe-dialog/crear-informe-dialog.component';
import { InformePersonalizadoService } from '../../../providers/informe-personalizado.service';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-crear-informe',
  templateUrl: './crear-informe.component.html',
  styleUrls: ['./crear-informe.component.scss']
})
export class CrearInformeComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();
  public tipoOferta: string;
  oferta: string = '';
  lista: any;
  constructor(
    public dialog: MatDialog,
    private datePipe: FormatDatePipe,
    private InformePersonalizadoService: InformePersonalizadoService
  ) { }

  ngOnInit() {

  }

  openDialog(): void {
    let dialogCrear = this.dialog.open(CrearInformeDialog, {
      disableClose: true
    });

    dialogCrear.afterClosed().subscribe(resultado => {
      console.log('Resultado del diálogo:', resultado); // Depuración
      if (resultado && resultado.archivo) {
        this.onCerrado.emit(resultado.archivo);
        this.generarCSV(resultado);
      } else {
        console.error('No data returned from dialog');
      }
    });
  }

  generarCSV(data: any[]): void {
    if (data.length === 0) {
      console.error('Empty data array');
      return;
    }
    
    console.log('Datos a exportar:', data); // Depuración
    const blob = new Blob([data['archivo']], { type: 'text/csv;charset=utf-8;' });
    const fecha = moment().format("YYYYMMDD_HHmmss");
    console.log('Iniciando descarga del archivo'); // Depuración
    saveAs(blob, `informe_${fecha}.csv`);
  }
}
